import React, { useMemo } from 'react';
import classnames from 'classnames';

import Icon from 'components/Icon';
import { ReactComponent as Empty } from 'undraw/empty.svg';

export const Progress = ({ progress, results, title, message }) => {
	// Check if there are no results
	const nothing = useMemo(() => {
		return !results?.length && !progress;
	}, [results, progress]);

	return nothing ?
		<div className="progress progress--nothing">
			{/* Drawing's component as raw svg */}
			<Empty
				height="172px"
				width="100%"
			/>

			{/* Nothing found title*/}
			<h3 className="withMarginTop">{title}</h3>

			{/* Nothing found message*/}
			<p>{message}</p>
		</div>
		: progress ?
			<div className="progress">
				<Icon
					icon="search"
					className="progress__icon progress__icon--withAnimation"
				/>
			</div>
			: null;
};

export const AdditionalProgress = ({ progress, results, title, message, className }) => {
	const nothing = useMemo(() => {
		return !results?.length && !progress;
	}, [results, progress]);
	
	const cls = useMemo(() => classnames(
		'progress__additional',
		'progress__additional--nothing',
		className
	), [className]);

	return nothing ?
		<div className={cls}>
			<h4>{title}<br/><small>{message}</small></h4>
		</div>
		: progress ?
			<div className="progress">
				<Icon
					icon="search"
					className="progress__icon progress__icon--withAnimation"
				/>
			</div>
			: null;
};

export const FormProgress = ({ progress }) => {
	return progress ?
		<div className="progress__mask">
			<div className="progress">
				<Icon
					icon="hourglass_empty"
					className="progress__icon progress__icon--withAnimation"
				/>
			</div>
		</div>
		: null;
};

export default Progress;
